// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { post } from "@insite/client-framework/Services/ApiService";

const uri = "api/vmi/orderapproval/reject";

export interface xDeclineOrderParameter {
    OrderNumber: string;
    Reason: string;
}

export interface xDeclineOrderCallbacks {
    onSuccess?: () => void;
    onError?: (errorMessage: string) => void;
}

export interface xDeclineOrderResponse {
    message: string;
}

export const xngDeclineOrder = async (parameter: xDeclineOrderParameter): Promise<xDeclineOrderResponse> => {
    const result = await post<xDeclineOrderParameter, xDeclineOrderResponse>(uri, parameter);
    return result;
};
